
  import { Injectable } from '@angular/core';
  import * as globalConstant from './../global_constant';
  
  declare var pintrk:Function
  
  @Injectable({
    providedIn: 'root'
  })
  export class PinterestService {
  
    constructor() {
      
    }
    pinterestData(itemEvent,pinterestData){        
        pintrk('track',itemEvent, pinterestData)
    }
 

  }
  